import { render } from "./SiteAbout.vue?vue&type=template&id=c01d3464"
import script from "./SiteAbout.vue?vue&type=script&lang=js"
export * from "./SiteAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__